import { Slider } from "../../components/slider/slider";
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
// Aos
import AOS from "aos";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';
// style
import './style/home.css'
// controller and hooks
import useGetData from "../../hook/getData";
import { GetBanners } from "../../services/client/banner/getBanner";
import { GetCategories } from "../../services/client/categories/getCategories";
import { GetProducts } from "../../services/client/products/getProducts";
// link
import { Link } from "react-router";
// components
import Category from "../../components/category/category";
import NewProducts from "../../components/newProduct/newProducts";
// options
import { CategorySettings } from "../../features/swiperOptions/swiperOptions";
import { useEffect, useMemo } from "react";
import { GetlatestBlog } from "../../services/client/blog/getBlogCategories";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
// img
import Divider from "../../components/divider/divider";
import productImg from './../../assets/media/icon/product.png'
import newsImg from './../../assets/media/icon/news.png'
import categoryImg from './../../assets/media/icon/category.png'
import logo from './../../assets/media/logo/logo.png'


const shuffleArray = <T,>(array: T[]): T[] => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
};

const Home = () => {
    const { data: sliders, isLoading } = useGetData(['sliders'], GetBanners)
    const { data: categoires } = useGetData(['categories'], GetCategories)
    const { data: Products } = useGetData(['products'], GetProducts)
    const { data: latestBlog } = useGetData(['latest-blog'], GetlatestBlog)

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        AOS.refreshHard();
    }, []);

    const shuffledDiscountProducts = useMemo(() => {
        return Products?.latestProducts
            ? shuffleArray(Products.latestProducts)
            : [];
    }, [Products?.latestProducts]);

    return (
        <>
            {isLoading ? (
                <>
                    <div className="container h-100 mt-5">
                        <div className="row h-100 justify-content-center py-5 align-items-center">
                            <div className="col-md-6 text-center">
                                <img alt="logo" className="acband-price-icon animate-logo" src={require('../../assets/media/logo/final.png')} />
                                <p className="fw-bold mt-3">
                                    در حال بارگذاری..
                                </p>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <section className="banners d-lg-none d-block bg-white py-1 mt-4">
                        <div className="container">
                            <div className="row gy-3 overflow-x-hidden">
                                <div className="col-lg-6">
                                    <Link to={'/categories/barbikio'} className="text-decoration-none">
                                        <div className="banner-bg banner-home banner-bg-se-2 px-4"></div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="banner-parent d-lg-block d-none bg-white">
                        <div className="container h-100">
                            <div className="row gy-3 align-items-center">
                                <div className="col-md-5 order-md-0 order-1">
                                    <img
                                        src={logo}
                                        alt="Logo"
                                        className="logo-img-big"
                                        loading="eager"
                                        decoding="async"
                                    />
                                    <h6 className="text-site font-medium mt-3" data-aos="fade-down" data-aos-duration="1500">
                                        کیفیت ماندگار، تحویل سریع، رضایت همیشگی
                                    </h6>
                                    <h1 className="fw-bold h2 mt-2" data-aos="zoom-in" data-aos-duration="1500">
                                        آریا استیل راد | تولید تجهیزات آشپزخانه
                                    </h1>
                                    <p className="card-text mt-3 line-30" data-aos="fade-up" data-aos-duration="1500">
                                        ما باور داریم کیفیت، مهم‌ترین سرمایه یک برند است.
                                        به همین دلیل ترجیح می‌دهیم زمان بیشتری صرف تولید و ارائه محصولی
                                        استاندارد و بادوام کنیم تا سال‌ها رضایت و اعتماد مشتریان را همراه داشته باشیم.
                                    </p>

                                    <button className="hero-btn btn-dark">
                                        مشاهده محصولات
                                        <IconChevronLeft />
                                    </button>
                                </div>
                                <div className="col-md-7 order-md-1 order-0">
                                    <Slider sliders={sliders} />
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="category bg-white py-3 mt-md-5">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-3 col-md-4">
                                    <div className="d-md-block d-none">
                                        <img src={categoryImg} alt="category" className="logo-img-new" />
                                        <p className="h5 fw-bold mt-2">
                                            دسته بندی
                                        </p>
                                        <p className="card-text line-30 mb-2">
                                            آریا استیل با ارائه تجهیزات صنعتی استاندارد، کیفیت و دوام را در کنار طراحی حرفه‌ای به آشپزخانه شما می‌آورد.
                                        </p>
                                        <span className="font-medium text-site d-block text-end mb-0">
                                            دسته بندی ها
                                            <IconChevronLeft size={12} />
                                        </span>
                                    </div>
                                    <div className="d-block d-md-none">
                                        <Divider title="دسته بندی" subtitile="بهترین محصولات" />
                                    </div>
                                </div>
                                <div className="col-lg-9 col-md-8">
                                    <Swiper
                                        {...CategorySettings}
                                    >
                                        {categoires ? (
                                            <>
                                                {categoires
                                                    ?.filter((category: any) => Number(category.parents.length) === 0)
                                                    .map((category: any) => (
                                                        <>
                                                            <SwiperSlide key={category.parent_id + 'newProduct'}>
                                                                <Category
                                                                    parent_id={category.parent_id}
                                                                    slug={category.slug}
                                                                    icon={category.icon}
                                                                    name={category.name}
                                                                />
                                                            </SwiperSlide>
                                                        </>
                                                    ))}
                                            </>
                                        ) : null}
                                    </Swiper>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="banners bg-white py-1 pb-3 my-4 mb-0 mt-md-4 mt-4">
                        <div className="container">
                            <div className="row gy-3 overflow-x-hidden">
                                <div className="col-md-6 d-md-inline-block d-none">
                                    <Link to={'/categories/barbikio'} className="text-decoration-none">
                                        <div className="banner-bg banner-bg-se-2 px-4"></div>
                                    </Link>
                                </div>
                                <div className="col-md-6">
                                    <Link to={'/categories/cooking-equipment'} className="text-decoration-none">
                                        <div className="banner-bg banner-bg-se-1 px-4"></div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="new-products bg-white py-md-0 pb-0 py-2 pb-3">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-9 col-md-8 order-md-0 order-1">
                                    {shuffledDiscountProducts ? (
                                        <Swiper
                                            {...CategorySettings}
                                        >
                                            {shuffledDiscountProducts?.map((product: any) => (
                                                <SwiperSlide key={product.id + 'newProduct'} className="py-3">
                                                    <NewProducts count={product?.quantity} price={product?.price} has_variation={product.has_variation} rate={product.average_rate} id={product.id} slug={product.slug} name={product.name} primary_image={product.primary_image} description={product.description} quantity_check={product.quantity_check} />
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    ) : null}
                                </div>
                                <div className="col-lg-3 col-md-4 order-md-1 order-0">
                                    <div className="d-md-block d-none">
                                        <img src={productImg} alt="category" className="logo-img-new" />
                                        <p className="h5 fw-bold mt-2">
                                            محصولات
                                        </p>
                                        <p className="card-text line-30 mb-2">
                                            آریا استیل با ارائه تجهیزات صنعتی استاندارد، کیفیت و دوام را در کنار طراحی حرفه‌ای به آشپزخانه شما می‌آورد.
                                        </p>
                                        <span className="font-medium text-site d-block text-end mb-0">
                                            <IconChevronRight size={12} />
                                            محصولات
                                        </span>
                                    </div>
                                    <div className="d-block d-md-none">
                                        <Divider title="محصولات" subtitile="جدیدترین ها " />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="container my-md-5 mt-0 mb-0 banner-parent-middle position-relative">
                        <div className="banner-ribbon">
                            <span>بهترین‌ها را با ما رقم بزنید</span>
                        </div>
                        <Swiper
                            modules={[Navigation, Pagination, Autoplay]}
                            slidesPerView={1}
                            navigation
                            spaceBetween={30}
                            pagination={{ clickable: true }}
                            loop={true}
                            autoplay={{
                                delay: 5500,
                            }}
                            className="mySwiper"
                        >
                            <SwiperSlide className="py-3">
                                <img className="banner-middle" src={require('./../../assets/media/banner/bannerEnd.webp')} alt="banner" />
                            </SwiperSlide>
                            <SwiperSlide className="py-3">
                                <img className="banner-middle" src={require('./../../assets/media/banner/bannerEndAbout.webp')} alt="banner" />
                            </SwiperSlide>
                            <SwiperSlide className="py-3">
                                <img className="banner-middle" src={require('./../../assets/media/banner/bannerEndContact.webp')} alt="banner" />
                            </SwiperSlide>
                        </Swiper>
                    </section>
                    {latestBlog?.data && (
                        <section id='lastBlog' className='my-3 container'>
                            <div className='row gy-2 align-items-center'>
                                <div className="col-lg-3 col-md-4">
                                    <div className="d-md-block d-none">
                                        <img src={newsImg} alt="category" className="logo-img-new" />
                                        <p className="h5 fw-bold mt-2">
                                            مجله آریا استیل
                                        </p>
                                        <p className="card-text line-30 mb-2">
                                            جدیدترین اخبار، مقالات تخصصی و نکات کاربردی حوزه تجهیزات آشپزخانه صنعتی را دنبال کنید و با تازه‌ترین فناوری‌ها و راهکارهای این صنعت همراه باشید.
                                        </p>
                                        <span className="font-medium text-site d-block text-end mb-0">
                                            اخبار
                                            <IconChevronLeft size={12} />
                                        </span>
                                    </div>
                                    <div className="d-block d-md-none">
                                        <Divider title="مجله آریا استیل" subtitile="آخرین مطالب" />
                                    </div>
                                </div>
                                <div className="col-lg-9 col-md-8 blog-items mt-0">
                                    <Swiper
                                        {...CategorySettings}
                                    >
                                        {latestBlog?.data?.map((blog: any) => (
                                            <SwiperSlide key={blog.id + 'newBlog'} className="py-3">
                                                <Link className='text-decoration-none' to={`/blog/detail/${blog.slug}`}>
                                                    <div className='card border-0 rounded rounded-4 blog-card b' style={{ backgroundImage: `url(https://admin.ariyasteelrad.ir/uploads/files/blog/posts/${blog.image})` }}>
                                                        <div className='d-flex h-100 align-items-end'>
                                                            <div className='linear-gradiant-blog'>
                                                                <div className='card-body'>
                                                                    {blog.title}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            </div>
                        </section>
                    )}
                </>
            )
            }
        </>
    )
}

export default Home;